import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useDepartmentSelect() {
  const { data, ...arg } = useQuery<{ departments: { id: number; name: string }[] }>(
    ['department-select'],
    async () => {
      const { data } = await $api.get('/v1/department/all');

      return { departments: data?.data };
    }
  );

  return { ...data, ...arg };
}
